/* DRESSFRESH 2026 · product buy panel (sections/df-product-main.liquid)
   Gallery, option → variant resolution, live price/total, quantity stepper, info tabs.
   Add to cart itself is handled by Taiga's <product-form> (component-product-form.js),
   which opens the existing cart drawer.
   Broadcasts `df:variant-change` on document so other df sections (scent story, etc.)
   can follow the selected option. */
(function () {
  'use strict';

  function handleize(s) {
    return String(s || '').toLowerCase().trim()
      .replace(/['"]/g, '').replace(/[^a-z0-9À-ɏ]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return '0';
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re), v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      default: v = delim(cents, 2);
    }
    return fmt.replace(re, v);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initProduct(root) {
    if (root.dataset.dfReady) return;
    root.dataset.dfReady = '1';

    var jsonEl = root.querySelector('[data-df-product-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    /* ── gallery ───────────────────────────── */
    var gal = root.querySelector('[data-df-gallery]');
    var slides = gal ? Array.prototype.slice.call(gal.querySelectorAll('.cslide')) : [];
    var thumbs = gal ? Array.prototype.slice.call(gal.querySelectorAll('[data-df-thumb]')) : [];
    var counter = gal ? gal.querySelector('[data-df-count]') : null;
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var galFiltered = slides.some(function (s) { return s.hasAttribute('data-df-media-scent'); });

    /* positions (in slides[]) the visitor can currently reach */
    function reachable() {
      var list = [];
      slides.forEach(function (s, k) { if (!s.hidden) list.push(k); });
      return list.length ? list : slides.map(function (s, k) { return k; });
    }
    function step(delta) {
      var list = reachable();
      var at = list.indexOf(current);
      go(list[(Math.max(at, 0) + delta + list.length) % list.length]);
    }
    /* show only the given scent's images plus the images that name no scent */
    function filterGallery(keys) {
      if (!galFiltered) return;
      function allowed(el) {
        var scent = el.getAttribute('data-df-media-scent');
        return !scent || keys.indexOf(scent) > -1;
      }
      slides.forEach(function (s) { s.hidden = !allowed(s); });
      thumbs.forEach(function (t) { t.hidden = !allowed(t); });
      var many = reachable().length > 1;
      var strip = gal.querySelector('.shopx__thumbs');
      if (strip) strip.hidden = !many;
      gal.querySelectorAll('[data-df-prev], [data-df-next], [data-df-count]').forEach(function (el) { el.hidden = !many; });
      if (slides[current].hidden) go(reachable()[0]);
      else go(current);
    }

    function go(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      var list = reachable();
      slides.forEach(function (s, k) {
        var on = k === current;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === current);
        t.setAttribute('aria-current', k === current ? 'true' : 'false');
      });
      if (galFiltered) {
        list.forEach(function (k, n) { slides[k].setAttribute('aria-label', (n + 1) + ' / ' + list.length); });
      }
      if (counter) counter.textContent = pad(list.indexOf(current) + 1) + ' / ' + pad(list.length);
    }
    function goToMedia(mediaId) {
      if (!mediaId) return;
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) go(idx);
    }
    if (gal) {
      var prev = gal.querySelector('[data-df-prev]');
      var next = gal.querySelector('[data-df-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-df-thumb'), 10)); });
      });
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { step(-1); }
        if (e.key === 'ArrowRight') { step(1); }
      });
      go(current);
    }

    /* ── purchase state ────────────────────── */
    var variantInput = root.querySelector('[data-df-variant-input]');
    var priceEl = root.querySelector('[data-df-price]');
    var compareEl = root.querySelector('[data-df-compare]');
    var addBtn = root.querySelector('[data-df-add]');
    var addLabel = root.querySelector('[data-df-add-label]');
    var fabLabel = root.querySelector('[data-df-fab-label]');
    var fab = root.querySelector('[data-df-fabcart]');
    var qtyInput = root.querySelector('[data-df-qty-input]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-df-option]'));

    var currentVariant = null;
    var initialId = variantInput ? parseInt(variantInput.value, 10) : null;
    data.variants.forEach(function (v) { if (v.id === initialId) currentVariant = v; });

    function qty() { return Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1); }

    /* Selected values: vals[i] = value for real product option i.
       displayOnly = the chosen scent is not a real variant value (data-df-real="false")
       or its fieldset is not a real product option (data-df-option="-1"). */
    function selection() {
      var vals = [], all = [], displayOnly = false;
      for (var i = 0; i < (data.optionCount || 0); i++) vals.push(null);
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (!checked) return;
        all.push(checked.value);
        var idx = parseInt(fs.getAttribute('data-df-option'), 10);
        if (checked.getAttribute('data-df-real') === 'false' || idx < 0) { displayOnly = true; return; }
        vals[idx] = checked.value;
      });
      return { vals: vals, all: all, displayOnly: displayOnly };
    }

    function resolveVariant(sel) {
      if (sel.displayOnly) return null;
      var found = null;
      data.variants.forEach(function (v) {
        if (found) return;
        var ok = v.options.every(function (o, i) { return sel.vals[i] == null || o === sel.vals[i]; });
        if (ok) found = v;
      });
      return found;
    }

    function render() {
      var v = currentVariant;
      var q = qty();
      if (v) {
        if (priceEl) priceEl.textContent = formatMoney(v.price * q, data.moneyFormat);
        if (compareEl) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = formatMoney(v.compare_at_price * q, data.moneyFormat);
        }
        var total = formatMoney(v.price * q, data.moneyFormat);
        if (addBtn) {
          if (v.available) addBtn.removeAttribute('disabled'); else addBtn.setAttribute('disabled', 'disabled');
        }
        if (addLabel) {
          addLabel.textContent = v.available
            ? data.buttonLabel + (data.priceInButton ? ' — ' + total : '')
            : data.soldOut;
        }
        if (fabLabel) fabLabel.textContent = (data.fabLabel || data.buttonLabel) + (data.priceInButton ? ' — ' + total : '');
        if (fab) fab.setAttribute('aria-label', (data.fabLabel || data.buttonLabel) + (data.priceInButton ? ' — ' + total : ''));
      } else {
        if (addBtn) addBtn.setAttribute('disabled', 'disabled');
        if (addLabel) addLabel.textContent = data.unavailable;
      }
    }

    function findSwatch(val) {
      var k = handleize(val);
      for (var name in data.swatches) { if (handleize(name) === k) return data.swatches[name]; }
      return '';
    }

    function syncOptionUI(sel) {
      fieldsets.forEach(function (fs) {
        var label = fs.querySelector('[data-df-option-label]');
        var checked = fs.querySelector('input:checked');
        if (!label || !checked) return;
        var btn = fs.querySelector('label[for="' + checked.id + '"] .sxopt__v');
        var shown = btn ? btn.textContent : checked.value;
        var desc = findSwatch(checked.value) || findSwatch(shown);
        label.textContent = shown + (desc ? ' · ' + desc : '');
      });
      var keys = sel.all.map(handleize);
      root.querySelectorAll('[data-df-scent-panel]').forEach(function (p) {
        p.hidden = keys.indexOf(p.getAttribute('data-df-scent-panel')) === -1;
      });
    }

    /* per-scent bottle image in the first gallery slot (only when the variant has no image of its own) */
    var firstSlide = slides[0] || null;
    var firstSlideHTML = firstSlide ? firstSlide.innerHTML : '';
    var firstSlideContain = firstSlide ? firstSlide.classList.contains('is-contain') : false;
    function restoreFirstSlide() {
      if (!firstSlide || !firstSlide.dataset.dfSwapped) return;
      firstSlide.innerHTML = firstSlideHTML;
      firstSlide.classList.toggle('is-contain', firstSlideContain);
      delete firstSlide.dataset.dfSwapped;
    }
    function syncGalleryImage(sel) {
      if (!firstSlide) return;
      filterGallery(sel.all.map(handleize));
      if (galFiltered) {
        /* each scent opens on its own first image */
        if (currentVariant && currentVariant.featured_media) goToMedia(currentVariant.featured_media);
        else go(reachable()[0]);
        return;
      }
      if (currentVariant && currentVariant.featured_media) {
        restoreFirstSlide();
        goToMedia(currentVariant.featured_media);
        return;
      }
      var tpl = null;
      sel.all.forEach(function (v) {
        if (!tpl) tpl = root.querySelector('template[data-df-swatch-img="' + handleize(v) + '"]');
      });
      if (tpl) {
        firstSlide.innerHTML = tpl.innerHTML;
        firstSlide.classList.add('is-contain');
        firstSlide.dataset.dfSwapped = '1';
        go(0);
      } else {
        restoreFirstSlide();
      }
    }

    function broadcast() {
      var sel = selection();
      document.dispatchEvent(new CustomEvent('df:variant-change', {
        detail: {
          productId: data.id,
          variant: currentVariant,
          options: sel.all,
          keys: sel.all.map(handleize)
        }
      }));
    }

    function update(isUserChange) {
      var sel = selection();
      currentVariant = resolveVariant(sel);
      if (currentVariant && variantInput) {
        variantInput.value = currentVariant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (isUserChange && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', currentVariant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      syncOptionUI(sel);
      syncGalleryImage(sel);
      render();
      broadcast();
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () { update(true); });
    });

    /* ── quantity ──────────────────────────── */
    var qtyWrap = root.querySelector('[data-df-qty]');
    if (qtyWrap && qtyInput) {
      qtyWrap.querySelectorAll('[data-df-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-df-step'), 10);
          var max = parseInt(qtyInput.getAttribute('max'), 10) || Infinity;
          qtyInput.value = Math.min(max, Math.max(1, qty() + step));
          render();
        });
      });
      qtyInput.addEventListener('input', render);
      qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
    }
    /* Taiga resets only hidden quantity inputs after add — keep our total in sync */
    document.addEventListener('ajaxProduct:added', function () { render(); });

    /* ── info tabs ─────────────────────────── */
    var tabsWrap = root.querySelector('[data-df-tabs]');
    if (tabsWrap) {
      var tabs = Array.prototype.slice.call(tabsWrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(tabsWrap.querySelectorAll('[role="tabpanel"]'));
      function activate(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var on = p.id === tab.getAttribute('aria-controls');
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); activate(tabs[(i + 1) % tabs.length], true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); activate(tabs[(i - 1 + tabs.length) % tabs.length], true); }
        });
      });
    }

    render();
    /* initial state (label, notes, bottle image, button) + let other sections
       (scent story) pick up the initial selection once they have initialised */
    setTimeout(function () { update(false); }, 0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-df-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.DF = window.DF || {};
  window.DF.formatMoney = formatMoney;
  window.DF.handleize = handleize;
})();
